<script>
export default {
}
</script>
<template>
  <icon-base>
    <g>
      <path d="M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z" />
    </g>
  </icon-base>
</template>